// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/auth/v1/auth.proto" (package "c1.api.auth.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.auth.v1.IntrospectRequest
 */
export interface IntrospectRequest {
}
/**
 * IntrospectResponse contains information about the current user who is authenticated.
 *
 * @generated from protobuf message c1.api.auth.v1.IntrospectResponse
 */
export interface IntrospectResponse {
    /**
     * The principleID of the current logged in user.
     *
     * @generated from protobuf field: string principle_id = 3
     */
    principleId: string;
    /**
     * The list of roles that the current logged in user has.
     *
     * @generated from protobuf field: repeated string roles = 4
     */
    roles: string[];
    /**
     * The list of permissions that the current logged in user has.
     *
     * @generated from protobuf field: repeated string permissions = 5
     */
    permissions: string[];
    /**
     * The userID of the current logged in user.
     *
     * @generated from protobuf field: string user_id = 6
     */
    userId: string;
    /**
     * The list of feature flags enabled for the tenant the logged in user belongs to.
     *
     * @generated from protobuf field: repeated string features = 11
     */
    features: string[];
}
/**
 * @generated from protobuf message c1.api.auth.v1.GetRUMRequest
 */
export interface GetRUMRequest {
}
/**
 * @generated from protobuf message c1.api.auth.v1.GetRUMResponse
 */
export interface GetRUMResponse {
    /**
     * @generated from protobuf field: string datadog_rum_app_id = 1
     */
    datadogRumAppId: string;
    /**
     * @generated from protobuf field: string datadog_rum_client_token = 2
     */
    datadogRumClientToken: string;
    /**
     * @generated from protobuf field: string datadog_site = 3
     */
    datadogSite: string;
    /**
     * @generated from protobuf field: string datadog_rum_env = 4
     */
    datadogRumEnv: string;
    /**
     * @generated from protobuf field: string datadog_rum_version = 5
     */
    datadogRumVersion: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectRequest$Type extends MessageType<IntrospectRequest> {
    constructor() {
        super("c1.api.auth.v1.IntrospectRequest", []);
    }
    create(value?: PartialMessage<IntrospectRequest>): IntrospectRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<IntrospectRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IntrospectRequest): IntrospectRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IntrospectRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.auth.v1.IntrospectRequest
 */
export const IntrospectRequest = new IntrospectRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectResponse$Type extends MessageType<IntrospectResponse> {
    constructor() {
        super("c1.api.auth.v1.IntrospectResponse", [
            { no: 3, name: "principle_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "roles", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "permissions", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "features", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<IntrospectResponse>): IntrospectResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.principleId = "";
        message.roles = [];
        message.permissions = [];
        message.userId = "";
        message.features = [];
        if (value !== undefined)
            reflectionMergePartial<IntrospectResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IntrospectResponse): IntrospectResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string principle_id */ 3:
                    message.principleId = reader.string();
                    break;
                case /* repeated string roles */ 4:
                    message.roles.push(reader.string());
                    break;
                case /* repeated string permissions */ 5:
                    message.permissions.push(reader.string());
                    break;
                case /* string user_id */ 6:
                    message.userId = reader.string();
                    break;
                case /* repeated string features */ 11:
                    message.features.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IntrospectResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string principle_id = 3; */
        if (message.principleId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.principleId);
        /* repeated string roles = 4; */
        for (let i = 0; i < message.roles.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.roles[i]);
        /* repeated string permissions = 5; */
        for (let i = 0; i < message.permissions.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.permissions[i]);
        /* string user_id = 6; */
        if (message.userId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.userId);
        /* repeated string features = 11; */
        for (let i = 0; i < message.features.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.features[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.auth.v1.IntrospectResponse
 */
export const IntrospectResponse = new IntrospectResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRUMRequest$Type extends MessageType<GetRUMRequest> {
    constructor() {
        super("c1.api.auth.v1.GetRUMRequest", []);
    }
    create(value?: PartialMessage<GetRUMRequest>): GetRUMRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetRUMRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetRUMRequest): GetRUMRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetRUMRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.auth.v1.GetRUMRequest
 */
export const GetRUMRequest = new GetRUMRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRUMResponse$Type extends MessageType<GetRUMResponse> {
    constructor() {
        super("c1.api.auth.v1.GetRUMResponse", [
            { no: 1, name: "datadog_rum_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "datadog_rum_client_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "datadog_site", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "datadog_rum_env", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "datadog_rum_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetRUMResponse>): GetRUMResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.datadogRumAppId = "";
        message.datadogRumClientToken = "";
        message.datadogSite = "";
        message.datadogRumEnv = "";
        message.datadogRumVersion = "";
        if (value !== undefined)
            reflectionMergePartial<GetRUMResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetRUMResponse): GetRUMResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string datadog_rum_app_id */ 1:
                    message.datadogRumAppId = reader.string();
                    break;
                case /* string datadog_rum_client_token */ 2:
                    message.datadogRumClientToken = reader.string();
                    break;
                case /* string datadog_site */ 3:
                    message.datadogSite = reader.string();
                    break;
                case /* string datadog_rum_env */ 4:
                    message.datadogRumEnv = reader.string();
                    break;
                case /* string datadog_rum_version */ 5:
                    message.datadogRumVersion = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetRUMResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string datadog_rum_app_id = 1; */
        if (message.datadogRumAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.datadogRumAppId);
        /* string datadog_rum_client_token = 2; */
        if (message.datadogRumClientToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.datadogRumClientToken);
        /* string datadog_site = 3; */
        if (message.datadogSite !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.datadogSite);
        /* string datadog_rum_env = 4; */
        if (message.datadogRumEnv !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.datadogRumEnv);
        /* string datadog_rum_version = 5; */
        if (message.datadogRumVersion !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.datadogRumVersion);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.auth.v1.GetRUMResponse
 */
export const GetRUMResponse = new GetRUMResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.auth.v1.Auth
 */
export const Auth = new ServiceType("c1.api.auth.v1.Auth", [
    { name: "Introspect", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/auth/introspect", group: "Auth" }] }, "authz.method": { role: "REFLECTION" } }, I: IntrospectRequest, O: IntrospectResponse },
    { name: "GetRUM", options: { "authz.method": { role: "REFLECTION" } }, I: GetRUMRequest, O: GetRUMResponse }
]);
